import * as ConnectedReactRouter from "connected-react-router";
import Urls from "utils/Urls";

const initialState = {};

export default (state = initialState, action) => {
  const { type, payload } = action;

  if (type === ConnectedReactRouter.LOCATION_CHANGE) {
    const { location: { search } } = payload;

    return Urls.parseQueryString(search);
  }

  return state;
};
